export const DEFAULT_MASK_TAG = '[MASKED]';
/**
 * Process value on all filter if they match
 * @param value value to be processed
 * @param filters filter to invoke on the value
 * @return parsed value on all matching filters if they match
 */
export const processFilters = (value, filters) => {
    let parsedValue = value;
    filters.forEach((filter) => {
        parsedValue = processValueOnFilter(parsedValue, filter);
    });
    return parsedValue;
};
/**
 * Calls @link {processFilters} if value has a value
 * @param value value or undefined
 * @param filters filters to process when value is set
 */
export const processFilterIfSet = (value, filters) => {
    if (!value) {
        return value;
    }
    return processFilters(value, filters);
};
/**
 * Process value on filter
 * @param value value to be processed
 * @param filter filter to process on the value
 * @return parsed value on filter if matched, else the input value is returned
 */
export const processValueOnFilter = (value, filter) => {
    if (filter.filterRegex) {
        return handleRegex(value, filter.filterRegex, filter.maskTag || DEFAULT_MASK_TAG, filter.exceptions);
    }
    if (filter.filterFn) {
        return filter.filterFn(value, filter.maskTag || DEFAULT_MASK_TAG, filter.exceptions);
    }
    // eslint-disable-next-line no-console
    console.warn(`Filter '${filter.name}' Ignored. No filter handling found`);
    return value;
};
/**
 * Find regex match in value and replace with maskTag except if the value exists in the exceptions list.
 * @param value Value to search regex matches
 * @param regex Regex to match on value
 * @param maskTag Tag to replace matched parts with
 * @param exceptions A list of match exceptions which are not replaced
 */
const handleRegex = (value, regex, maskTag, exceptions) => {
    return value.replace(regex, (match) => {
        // check if match is in exceptions list or if an exception is a substring of the match
        if (exceptions.some((exception) => match.includes(exception))) {
            return match;
        }
        return maskTag;
    });
};
//# sourceMappingURL=filter.js.map